import React from "react";
import { Modal } from "react-bootstrap";

import { RegisterModalContent } from "../RegisterModalContent/index"

export const ReactRegisterModal = ({ labels, show, setShow, lastAction, programName }) => {

  const handleClose = () => setShow(false);

  return (
    <Modal show={show} onHide={handleClose} className="login-modal">
      <RegisterModalContent labels={labels} handleClose={handleClose} lastAction={lastAction} programName={programName}/>
    </Modal>
  )
}